'use client';

import * as React from 'react';
import type { Transition, Variants } from 'framer-motion';
import { motion, useAnimation } from 'framer-motion';

interface IconProps {
	isHovered: boolean;
}

const circleTransition: Transition = {
	duration: 0.3,
	delay: 0.1,
	opacity: { delay: 0.15 },
};

const circleVariants: Variants = {
	normal: {
		pathLength: 1,
		opacity: 1,
	},
	animate: {
		pathLength: [0, 1],
		opacity: [0, 1],
	},
};

export function RouteIcon({ isHovered }: IconProps) {
	const controls = useAnimation();

	React.useEffect(() => {
		void controls.start(isHovered ? 'animate' : 'normal');
	}, [isHovered, controls]);

	return (
		<div className='select-none p-2 flex items-center justify-center'>
			<svg
				xmlns='http://www.w3.org/2000/svg'
				width='24'
				height='24'
				viewBox='0 0 24 24'
				fill='none'
				stroke={isHovered ? '#FF69B4' : 'currentColor'}
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			>
				<motion.circle
					cx='6'
					cy='19'
					r='3'
					transition={circleTransition}
					variants={circleVariants}
					animate={controls}
				/>
				<motion.path
					d='M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15'
					transition={{
						duration: 0.7,
						delay: 0.5,
						opacity: { delay: 0.5 },
					}}
					variants={{
						normal: {
							pathLength: 1,
							opacity: 1,
							pathOffset: 0,
						},
						animate: {
							pathLength: [0, 1],
							opacity: [0, 1],
							pathOffset: [1, 0],
						},
					}}
					animate={controls}
				/>
				<motion.circle
					cx='18'
					cy='5'
					r='3'
					transition={circleTransition}
					variants={circleVariants}
					animate={controls}
				/>
			</svg>
		</div>
	);
}
